/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import lottie from "lottie-web";
import Flickity from "flickity";
import gsap from "gsap";
import Isotope from "isotope-layout";
import Cookies from 'js-cookie'

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    this.legalScreen();
    this.bodymovin();
    this.isotope();
    this.carouselProgrammation();
    this.carouselBlog();
    this.menu();
    this.accordion();
    this.inViewport();
  }

  legalScreen() {
    const elts = document.querySelectorAll('.legal-screen');
    console.log(elts);

    if( elts ) {
      elts.forEach(el => {
        const form = el.querySelector('form');
        if( form ) {
          const year = form.querySelector('input[name="year"]');

          year.addEventListener('input', function () {
              this.value = this.value.replace(/\D/g, '');
          });

          form.addEventListener('submit', (e) => {
            e.preventDefault();
            const now = new Date();

            if (year.value.length !== 4) { 
              year.classList.remove('animate-shake'); // Permet de relancer l'animation même si elle vient de se terminer 
              void year.offsetWidth; 
              year.classList.add('animate-shake'); 
              return false; 
            }

            if( parseInt(now.getFullYear()) - parseInt(year.value) >= 18 ) {
              Cookies.set('majeur', 1, { expires: 7 });
              gsap.to(el, {
                autoAlpha: 0,
                duration: 0.3,
                onComplete: () => {
                  el.remove();
                }
              })
            } else {
              form.querySelector('.msg').classList.remove('hidden');
            }

            return false;
          })
        }
      })
    }
  }

  menu() {
    // TOGGLE MENU
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();

          HTML.classList.toggle("open-menu");
          mainNav.dispatchEvent(new Event("toggle"));
        });
      });

      /** Menu */
      const mainNav = document.querySelector(".main-nav");
      if (mainNav) {
        mainNav.addEventListener("toggle", () => {
          const videos = mainNav.querySelectorAll("video");
          const anims = mainNav.querySelectorAll("[data-bodymovin]");

          if (HTML.classList.contains("open-menu")) {
            if (videos) {
              videos.forEach((video) => {
                video.play();
              });
            }

            if (anims) {
              anims.forEach((anim) => {
                anim.lottie.play();
              });
            }
          } else {
            if (videos) {
              videos.forEach((video) => {
                video.pause();
              });
            }

            if (anims) {
              anims.forEach((anim) => {
                anim.lottie.pause();
              });
            }
          }
        });

        window.addEventListener("load", () => {
          mainNav.dispatchEvent(new Event("toggle"));
        });
      }
    }
  }

  isotope() {
    const containers = document.querySelectorAll(".isotope");
    if (containers) {
      containers.forEach((el) => {
        const container = el.querySelector(".isotope-container");
        const filters = el.querySelectorAll(".isotope-filter");

        if (container) {
          const iso = new Isotope(container, {
            itemSelector: ".item",
            layoutMode: "masonry",
          });

          if (filters) {
            const _filters = [];
            filters.forEach((filter) => {
              filter.addEventListener("change", (e) => {
                e.preventDefault();

                /** Clear filters */
                const type = filter.getAttribute("name");
                let cursor = 0;
                for (const _filter of _filters) {
                  if (_filter == "") continue;
                  const index = _filter.indexOf(type);
                  if (index >= 0) {
                    _filters.splice(cursor, 1);
                    cursor--;
                  } else {
                    cursor++;
                  }
                }

                if (filter.value != "*")
                  _filters.push(`.${type}-${filter.value}`);

                console.log(_filters.join(""));

                iso.arrange({ filter: _filters.join("") });
              });
            });
          }
        }
      });
    }
  }

  carouselProgrammation() {
    const elts = document.querySelectorAll(".carousel-programmation");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          wrapAround: true,
          pageDots: false,
          cellAlign: "center",
          prevNextButtons: false,
          freeScroll: true,
        });

        const pas = el.dataset.speed
          ? Number.parseFloat(el.dataset.speed)
          : 0.65;

        flkty.request = 0;

        function play() {
          flkty.x -= -1 * pas;
          flkty.settle(flkty.x);
          flkty.request = window.requestAnimationFrame(play);
        }

        el.addEventListener("inview", (e) => {
          play();
        });
        el.addEventListener("mouseleave", (e) => {
          play();
        });
        el.addEventListener("mouseenter", () => {
          window.cancelAnimationFrame(flkty.request);
        });
        el.addEventListener("outview", () => {
          window.cancelAnimationFrame(flkty.request);
        });
      });
    }
  }

  carouselBlog() {
    const elts = document.querySelectorAll(".carousel-blog");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          cellAlign: "left",
          contain: true,
          pageDots: false,
          on: {
            select(index) {
              const nbVisible = Math.ceil(
                this.size.width / this.slides[0].outerWidth
              );

              if (index == 0) {
                this.prevButton.element.classList.add("disabled");
              } else {
                this.prevButton.element.classList.remove("disabled");
              }

              if (index + nbVisible == this.cells.length + 1) {
                this.nextButton.element.classList.add("disabled");
              } else {
                this.nextButton.element.classList.remove("disabled");
              }
            },
          },
        });
      });
    }
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: anim,
                });
                tag.classList.add("loaded");
                tag.lottie = l;
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            tag.lottie.pause();
          }
        });
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((accordion) => {
        const triggers = accordion.querySelectorAll(".accordion-header");
        const contents = accordion.querySelectorAll(".accordion-content");

        if (triggers && contents) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              const parent = trigger.closest(".accordion-item");
              parent.classList.toggle("active");

              if (contents[i]) {
                const child = contents[i].children[0];

                gsap.to(contents[i], {
                  duration: 0.6,
                  ease: "circ.inOut",
                  height: parent.classList.contains("active")
                    ? child.offsetHeight
                    : 0,
                });
                gsap.to(child, {
                  duration: 0.4,
                  autoAlpha: parent.classList.contains("active") ? 1 : 0,
                  delay: parent.classList.contains("active") ? 0.2 : 0,
                });
              }
            });
          });
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
